import { LoginRequest, LoginResponse } from "@/models/user.model";
import http from "@/services/http";

export async function login(request: LoginRequest): Promise<LoginResponse> {
  return http.post<LoginResponse>("/auth/login", request);
}
